import { FluentProvider } from "@fluentui/react-components";
import { duploLightTheme, Button, Label, TextStyle } from "@lannister/duplo";

import "../paymentLink/styles.css";
import PoweredBy from "./poweredBy";


const CheckoutView = ({
    children, merchantLogo, isButtonLoading, onSubmit, isAllFieldsValid, buttonLabel, title }) => {

  return (
    <FluentProvider theme={duploLightTheme}>
      <div style={styles.page}>

        <div style={styles.content}>
          { merchantLogo && 
            <div style={styles.logoPlaceholder}>
              <img src={merchantLogo} style={styles.logoImage} alt="merchant" />
            </div> }

          <div style={styles.card}>
            <Label
                labelText={title}
                textStyle={TextStyle.Heading5Semibold}
            />
            {children}
          </div>

          <PoweredBy />
        </div>

        <div style={styles.bottomBar}>
            <div style={{ display: "grid", width: "100%" }}>
                <Button
                    isLoading={isButtonLoading}
                    onClick={onSubmit}
                    disabled={!isAllFieldsValid}
                >
                    {buttonLabel}
                </Button>
            </div>
        </div>
      </div>
    </FluentProvider>
  );
};

const styles = {
  page: {
    minHeight: "100dvh",
    backgroundColor: "#FFFFFF",
    position: "relative",
    overflowX: "hidden",
  },

  content: {
    padding: "24px 24px 120px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },

  logoPlaceholder: {
    width: "144px",
    height: "144px",
    margin: "0 auto 12px",
    borderRadius: "14px",
    border: "1px solid #E1E4FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  logoImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },

  card: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E6E8FA",
    backgroundColor: "#FFFFFF",
    alignSelf: "stretch",
  },

  bottomBar: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    padding: "20px 24px calc(20px + env(safe-area-inset-bottom))",
    backgroundColor: "#FFFFFF",
    borderTop: "1px solid #E6E6E6",
  },
};

export default CheckoutView;
